import { NavLink } from "react-router-dom";
import "layout/Navbar/Navbar.scss";
import { ReactComponent as HomeIcon } from "assets/images/icons/home.svg";
import { ReactComponent as MailIcon } from "assets/images/icons/mail.svg";
import { ReactComponent as SearchIcon } from "assets/images/icons/search.svg";
import { ReactComponent as PinIcon } from "assets/images/icons/pin.svg";

function Navbar() {
  const navigation = [
    { title: 'Startpagina', link: '/startpagina', icon: <HomeIcon/> },
    { title: 'Leden zoeken', link: '/leden', icon: <SearchIcon/> },
    { title: 'Berichtenbox', link: '/berichtenbox', icon: <MailIcon/> },
    { title: 'Ledenprikbord', link: '/prikbord', icon: <PinIcon/> },
  ];

  return (
    <div className="navbar">
      { navigation.map((nav, index) => (
        <div className={ `navbar__item` } key={ index }>
          <NavLink to={ nav.link }
                   activeClassName={ `active` }
                   key={ index }>
            { nav.icon }
            { nav.title }
          </NavLink>
        </div>
      )) }
    </div>
  )
}

export default Navbar;
